import { FormattedMessage } from 'react-intl';

import { LinkButton } from '@atlaskit/button-next/new';
import Heading from '@atlaskit/heading';
import { Box, Flex, Stack, xcss } from '@atlaskit/primitives-next';

import { useRoutes } from '../../../hooks';
import { CautionVector } from '../../assets';

import { use404DisplayAnalytics } from './hooks';
import { messages } from './messages';

const iconContainerStyles = xcss({
	width: '180px',
	height: '180px',
});

export const FourOhFourDisplay = () => {
	const { paths } = useRoutes();

	const { sendGoBackToHomeLinkClickUIEvent } = use404DisplayAnalytics();

	return (
		<Box padding="space.400">
			<Stack alignBlock="center" space="space.300" alignInline="center">
				<Flex xcss={iconContainerStyles} alignItems="center" justifyContent="center">
					<CautionVector />
				</Flex>
				<Heading size="small" as="h1">
					<FormattedMessage {...messages.fourOhFourHeading} />
				</Heading>

				<LinkButton
					appearance="primary"
					href={paths.home}
					onClick={() => sendGoBackToHomeLinkClickUIEvent()}
				>
					<FormattedMessage {...messages.fourOhFourBackButtonText} />
				</LinkButton>
			</Stack>
		</Box>
	);
};
